import axios from 'axios';

import {
  CreateVenueAdCampaignRequest,
  VenueAdCampaignResponse,
  VenueAdCampaignListResponse,
  PatchVenueAdCampaignRequest,
  VenueAdCampaignConfigResponse,
  MerchantAdCampaignResponse,
  MerchantAdCampaignConfigResponse,
  CreateMerchantAdCampaignRequest,
} from './types';

const adBookingsServiceApi = axios.create({
  baseURL: process.env.AD_BOOKINGS_URI,
});

export default adBookingsServiceApi;

export const getVenueAdCampaignConfiguration = async (
  venueId: string,
  country: Country,
): Promise<VenueAdCampaignConfigResponse> => {
  const res = await adBookingsServiceApi.get<VenueAdCampaignConfigResponse>(
    `/public/merchant-admin/venues/${venueId}/configuration?country=${country}`,
  );
  return res.data;
};

export const getMerchantAdCampaignConfiguration = async (): Promise<MerchantAdCampaignConfigResponse> => {
  return {
    currency: 'USD',
    default_budget_amounts: {
      low: 100,
      recommended: 200,
      high: 300,
    },
    maximum_custom_bid_amount: 150,
    minimum_budget_amount: 50,
    maximum_budget_amount: 500,
    minimum_bid_amount: 10,
    estimated_return_on_spending: 0.75,
  };
};

export const createFreeTrialsVenueAdCampaign = async (
  venueId: string,
  campaign: CreateVenueAdCampaignRequest,
): Promise<VenueAdCampaignResponse> => {
  const res = await adBookingsServiceApi.post(
    `/public/merchant-admin/venues/${venueId}/campaigns/free-trial`,
    campaign,
  );
  return res.data;
};

export const createVenueAdCampaign = async (
  venueId: string,
  request: CreateVenueAdCampaignRequest,
): Promise<VenueAdCampaignResponse> => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns`, request);
  return res.data;
};

export const createMerchantAdCampaign = async (
  request: CreateMerchantAdCampaignRequest,
): Promise<MerchantAdCampaignResponse> => {
  return {
    id: '123456',
    venue_ids: ['789', '456'],
    merchant_id: request.merchant_id,
    start_date: '2022-01-01',
    end_date: '2022-01-31',
    latest_stopped_at: undefined,
    weekly_budget_amount: 500,
    bid_amount: 100,
    bid_strategy: 'AUTOMATIC',
    status: 'RUNNING',
    created_by: 'JohnDoe',
    name: 'Sample Campaign',
  };
};

export const getVenueAdCampaignList = async (
  venueId: string,
  startDateAfter?: string,
): Promise<VenueAdCampaignListResponse> => {
  const res = await adBookingsServiceApi.get<VenueAdCampaignListResponse>(
    `/public/merchant-admin/venues/${venueId}/campaigns`,
    {
      params: {
        startDateAfter,
      },
    },
  );
  return res.data;
};

export const getVenueAdCampaign = async (venueId: string, campaignId: string): Promise<VenueAdCampaignResponse> => {
  const res = await adBookingsServiceApi.get<VenueAdCampaignResponse>(
    `/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}`,
  );
  return res.data;
};

export const getMerchantAdCampaign = async (): Promise<MerchantAdCampaignResponse> => {
  return {
    id: 'fake-campaign',
    venue_ids: ['789', '456'],
    merchant_id: '987654',
    start_date: '2022-01-01',
    end_date: '2022-01-31',
    latest_stopped_at: undefined,
    weekly_budget_amount: 500,
    bid_amount: 100,
    bid_strategy: 'AUTOMATIC',
    status: 'RUNNING',
    created_by: 'JohnDoe',
    name: 'Sample Campaign',
  };
};

export const patchVenueAdCampaign = async (
  venueId: string,
  campaignId: string,
  campaign: PatchVenueAdCampaignRequest,
): Promise<VenueAdCampaignResponse> => {
  const res = await adBookingsServiceApi.patch(
    `/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}`,
    campaign,
  );
  return res.data;
};

export const stopVenueAdCampaign = async (venueId: string, campaignId: string) => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}/stop`);
  return res.data;
};

export const startVenueAdCampaign = async (venueId: string, campaignId: string) => {
  const res = await adBookingsServiceApi.post(`/public/merchant-admin/venues/${venueId}/campaigns/${campaignId}/start`);
  return res.data;
};
